import { makeStyles } from '@mui/styles';
import { LYNKED_DEEP_GREEN, LYNKED_WHITE } from '../../../../consts/colors';

const useStyles = makeStyles(() => ({
  selectIcon: {
    color: 'white',
    fontSize: '20px',
    top: 'unset',
  },
  Box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '5px',
    padding: '0 5px',
    minWidth: '130px',
  },
  select: {
    '& li': {
      color: LYNKED_WHITE,
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: LYNKED_DEEP_GREEN,
    },
    '& li:hover': {
      backgroundColor: '#1c3317',
    },
    '& .Mui-selected': {
      backgroundColor: LYNKED_DEEP_GREEN,
    },
    '& .Mui-selected:hover': {
      backgroundColor: '#1c3317',
    },
    '&': {
      left: 'initial !important',
      right: '90px',
      backgroundColor: LYNKED_DEEP_GREEN,
    },
  },
}));

export { useStyles };
